import Service from "../../components/Service/Service";

const ServicePage = () => {
  return <Service />;
};

export default ServicePage;
